<template>
    <div class="admin-management-wrap">
        <ul class="custom-tabbar">
            <li v-for="(tabItem, tabIndex) in tabList" :key="tabIndex" :class="{ active: tabItem.name == activeName }"
                @click="handleClickTab(tabItem.name)">
                <span>{{ tabItem.label }}</span>
            </li>
        </ul>
        <div class="admin-management-content">
            <template v-if="activeName == 'SetFields'">
                <SetFields/>
            </template>
            <template v-else-if="activeName == 'PersonnelLabel'">
                <PersonnelLable/>
            </template>
            <template v-else>
                <BusinessCardSet/>
            </template>
        </div>
    </div>
</template>
<script>
    import PersonnelLable from './personnel_lable.vue';
    import BusinessCardSet from './business_card_set.vue';
    import SetFields from './set_fields.vue';

    export default {
        name: "PersonnelAdminManagement",
        components: {PersonnelLable, BusinessCardSet, SetFields},
        data() {
            return {
                activeName: "SetFields",
                tabList: [
                    {name: "SetFields", label: "设置字段"},
                    {name: "PersonnelLabel", label: "人员标签"},
                    {name: "BusinessCardSet", label: "名片设置"},
                ],
            }
        },
        methods: {
            handleClickTab(name) {
                this.activeName = name;
            }
        }
    }
</script>
<style lang="scss" scoped>
    .admin-management-wrap {
        height: 100%;
        display: flex;
        flex-direction: column;

        .custom-tabbar {
            position: relative;
            padding: 0 16px;
            border-bottom: 1px solid #e8e8e8;
            flex-shrink: 0;

            li {
                display: inline-block;
                vertical-align: top;
                height: 48px;
                line-height: 48px;
                padding: 0 16px;
                position: relative;
                font-size: 16px;
                font-weight: 400;
                letter-spacing: 0px;
                color: rgba(102, 102, 102, 1);
                cursor: pointer;

                &.active {
                    font-size: 16px;
                    font-weight: 700;
                    letter-spacing: 0px;
                    color: rgba(41, 144, 255, 1);

                    &::after {
                        content: "";
                        display: block;
                        position: absolute;
                        left: 0;
                        right: 0;
                        width: 100%;
                        bottom: 0;
                        height: 2px;
                        opacity: 1;
                        background: #2990ff;
                    }
                }
            }
        }

        .admin-management-content {
            flex: 1;
            height: calc(100vh - 90px);
        }
    }
</style>
